
<template>
    <div>
        <div class="content">
          <lk-card title="处方信息">
            <div>
              <lk-form :label-width='160' label-position='right'>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='医保处方编号:'>
                      <span>{{info.rxNo}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='定点医疗机构名称:'>
                      <span>{{info.fixmedinsName}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='开方科室名称:'>
                      <span>{{info.prscDeptName}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='开方时间:'>
                      <span>{{formatDate}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='处方类别名称:'>
                      <span class="totalPay">{{info.rxTypeName}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='诊断名称:'>
                      <span>{{info.maindiagName}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='病情描述:'>
                      <span>{{info.diseCondDscr}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='病种编码:'>
                      <span>{{info.diseCodg}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='病种名称:'>
                      <span>{{info.diseName}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='患者姓名:'>
                      <span>{{info.patnName}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='年龄:'>
                      <span>{{info.patnAge}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='性别:'>
                      <span>{{info.gend == 1 ? '男' : '女'}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='过敏史:'>
                      <span>{{info.algsHis}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='处方原件:'>
                      <a v-bind:href="info.rxPic" target="_blank">下载处方</a>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-form>
            </div>
          </lk-card>
        </div>
      </div>
</template>
<script>

import utils from '../../libs/utils';

export default {
  computed: {
    formatDate() {
      return utils.formatDate(this.info.prscTime);
    },
  },
  props: {
    info: {
      type: Object,
    },
  },
  data() {
    return {
      name: '',
      showModal: this.status,
    };
  },
  methods: {
    handleSure() {

    },
  },
};
</script>

<style scoped>
.content {
  padding-top: 10px;
}
</style>